import React, { useState, useEffect, useCallback, useRef } from 'react';

import Dim from 'web/components/common/modal/common/Dim';

import * as input from 'web/components/common/modal/common/input';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import classNames from 'classnames/bind';
import styles from './DeviceList.scss';
const cx = classNames.bind(styles);

const DeviceList = React.memo(
  ({
    list = [],
    selectItem,
    handleSelect,
    handleDeleteItem,
    handleSubmit,
    handlePopup,
    handleModify,
    isController = false,
  }) => {
    const [bottomButtonClassName, setBottomButtonClassName] = useState([]);

    useEffect(() => {
      if (typeof selectItem === 'number') {
        setBottomButtonClassName(['active']);
      } else {
        setBottomButtonClassName([]);
      }
    }, [selectItem]);

    return (
      <Dim>
        <div
          className={cx('DeviceList', `isController-${isController}`)}
          onClick={e => e.stopPropagation()}
        >
          <div className="title">
            등록 기기 {isController ? '관리' : '변경'}
          </div>
          <div className="description">
            <span className="underline">{list.length}대</span>의 기기가 등록되어
            있습니다.
          </div>

          <form onSubmit={handleSubmit}>
            <div className="list-wrapper">
              <div className="device-header">
                <span className="first">등록일</span>
                <span className="secound">등록일</span>
              </div>
              <div className="device-content">
                <ul className={`device-list`}>
                  {list.map((li, i) => {
                    // console.log({ li });
                    return (
                      <DeviceItem
                        isController={isController}
                        selectItem={selectItem}
                        li={li}
                        i={i}
                        handleSelect={handleSelect}
                        handleDeleteItem={handleDeleteItem}
                        handleModify={(id, name) => {
                          handleModify(id, name, i);
                        }}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>

            {!isController && (
              <input.BottomButton
                type={'submit'}
                className={bottomButtonClassName}
                msg={``}
                onClick={handleSubmit}
              >
                변경
              </input.BottomButton>
            )}
            {isController && (
              <CloseBtn className={['close-btn']} onClick={handlePopup.close} />
            )}
          </form>
        </div>
      </Dim>
    );
  },
);

export default DeviceList;

const DeviceItem = React.memo(
  ({
    isController,
    selectItem,
    li,
    i,
    handleSelect,
    handleDeleteItem,
    handleModify,
  }) => {
    const [name, setName] = useState(li.name);
    const [modify, setModify] = useState(false);
    const inputNameEl = useRef(null);

    const active = selectItem === i ? true : false;

    const handleChangeName = useCallback(async () => {
      if (active) {
        await setModify(true);
        inputNameEl && inputNameEl.current && inputNameEl.current.focus();
      }
    }, [modify, active]);
    const handleChange = useCallback(
      e => {
        setName(e.target.value);
      },
      [setName],
    );
    const handleBlur = useCallback(
      e => {
        e.preventDefault();
        if (name) handleModify(li.id, name);
        setModify(false);
      },
      [handleModify, name],
    );

    if (!active && modify) {
      setModify(false);
    }

    return (
      <li
        key={`device-list-key-${i}`}
        className={`device-item ${active ? 'active' : ''} my-device-${
          li.myDevice
        }`}
        onClick={() => handleSelect(i)}
        style={{ cursor: 'pointer' }}
      >
        <span className="first registerDate">{li.registerDate}</span>
        {!modify ? (
          <span
            className={`secound name`}
            onClick={isController ? handleChangeName : null}
            style={isController ? { cursor: 'pointer' } : {}}
          >
            <span className="name">
              {li.name}
              <span className="deviceType">({li.deviceType})</span>
            </span>
          </span>
        ) : active && modify ? (
          <span className="secound name modify">
            <form onSubmit={handleBlur}>
              <input
                className="name-input"
                type="text"
                name="name"
                value={name}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={inputNameEl}
              />
              <button
                className="small-btn save"
                type="submit"
                onClick={handleBlur}
              >
                저장
              </button>
              <button
                className="small-btn delete"
                type="button"
                onClick={e => {
                  e.stopPropagation();
                  handleDeleteItem(i);
                }}
              >
                삭제
              </button>
            </form>
          </span>
        ) : (
          ''
        )}
      </li>
    );
  },
);
